'use strict';

const SELECTOR__CE_CONTAINER = '.ce.ce--vd_medical_journals';
const SELECTOR__SUBMIT_BUTTON = 'button.vd-filter-button--filter-results';

const EXT_KEY = 'vdtheme_laekb';
const EXT_EXTENSION = 'tx_vdthemelaekb';

let params = {
  extKey: EXT_KEY,
  extension: EXT_EXTENSION,
};

const init__onReady = () => {
  filterAction();
};

const filterAction = () => {
  const typeNum = 1697048847;

  $(document).on(
    'click',
    `${SELECTOR__CE_CONTAINER} button.vd-filter-button--filter-results`,
    function (e) {
      e.preventDefault();
      const form = $(this).closest('form');
      const url = `/?type=${typeNum}`;
      const formData = new FormData(form[0]);
      ajaxCall(url, formData, $(this));
    }
  );
};
const ajaxCall = (url, formData, _caller, options) => {
  if (url && formData) {
    fetch(url, {
      cache: 'no-store',
      method: 'POST',
      body: formData,
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        require('Webpack/Modules/JQuery/scrollToElement');
        _caller
          .parents(SELECTOR__CE_CONTAINER)
          .find('.container--result-list .row--list')
          .html(html)
          .scrollTo(333);
      })
      .catch(function (reason) {
        console.warn('Failure in filterAction', reason);
      });
  }
};

const domReady = (cb) => {
  document.readyState === 'interactive' || document.readyState === 'complete'
    ? cb()
    : document.addEventListener('DOMContentLoaded', cb);
};

domReady(() => {
  init__onReady();
});
